import React from 'react'

export const ChevronDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon
  <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="2" />
  </svg>
)
